import { render } from "./stronaOgloszeniaAds.vue?vue&type=template&id=04bb8d04&scoped=true"
import script from "./stronaOgloszeniaAds.vue?vue&type=script&lang=js"
export * from "./stronaOgloszeniaAds.vue?vue&type=script&lang=js"

import "./stronaOgloszeniaAds.vue?vue&type=style&index=0&id=04bb8d04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bb8d04"]])

export default __exports__